import { createLoader } from '@meteor/data-hooks';
import { withAuth } from '../auth/withAuth';
import { userClient } from '../client';
import { userLoader } from './user';

export let userEmailsLoader = createLoader({
  name: 'userEmails',
  parents: [userLoader],
  fetch: () => userClient.userEmail.list({}),
  mutators: {
    create: (i: { email: string }) => withAuth(() => userClient.userEmail.create(i)),
    delete: (i: { userEmailId: string }) => withAuth(() => userClient.userEmail.delete(i)),
    setPrimary: (i: { userEmailId: string }) =>
      withAuth(() => userClient.userEmail.setPrimary(i))
  }
});

export let useUserEmails = () => {
  let emails = userEmailsLoader.use();

  return {
    ...emails,

    createMutator: emails.useMutator('create'),
    deleteMutator: emails.useMutator('delete'),
    setPrimaryMutator: emails.useMutator('setPrimary')
  };
};
